export default __webpack_public_path__ + "static/media/1530.77e4a555.png";